var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCircleQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0ZM8 12.5C8.53125 12.5 9 12.0625 9 11.5C9 10.9375 8.53125 10.5 8 10.5C7.40625 10.5 7 10.9375 7 11.5C7 12.0625 7.4375 12.5 8 12.5ZM10.1562 8.0625C10.8438 7.65625 11.25 6.9375 11.25 6.1875C11.25 4.96875 10.2812 4 9 4H7.40625C6.21875 4 5.25 4.96875 5.25 6.1875C5.25 6.59375 5.59375 6.9375 6 6.9375C6.40625 6.9375 6.75 6.59375 6.75 6.1875C6.75 5.8125 7.03125 5.5 7.4375 5.5H9.03125C9.40625 5.5 9.75 5.8125 9.75 6.1875C9.75 6.4375 9.625 6.65625 9.40625 6.78125L7.625 7.84375C7.375 8 7.25 8.25 7.25 8.5V9C7.25 9.40625 7.59375 9.75 8 9.75C8.40625 9.75 8.75 9.40625 8.75 9V8.9375L10.1562 8.0625Z",
    fill: "#AAB4BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCircleQuestionMark);
export default __webpack_public_path__ + "static/media/icons_circle_question_mark.716743d4.svg";
export { ForwardRef as ReactComponent };